import { useRef, useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';

import { getFlightsById } from '@shared/services/services';
import { setSearchData } from '@shared/helpers/flights/shared-helpers';
import { setSharedSearch } from '@shared/redux/actions';

import TabsHeader from '@shared/components/TabsHeader';
import FlightsSearchForm from '@shared/pages/Flights/FlightsSearchForm';
import LoadingImage from '@shared/components/LoadingImage';

import NoResultsFlight from './NoResultsFlight';
import TimedModal from './TimedModal';
import Search from './Search';
import FlightsSearchSkeleton from './FlightsSearchSkeleton';
import { FLIGHTS } from '@shared/helpers/routes';

const FlightsSearch = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();
  const searchRef = useRef(null);

  const sharedSearch = useSelector(store => store.sharedSearch);

  const isNewSearch = useSelector(store => store.isNewSearch?.isNewSearch);

  const flightsSearch = useSelector(store => store.flightsSearch);

  const search_type = flightsSearch?.currentTripType;

  const originalSearchType = useSelector(
    store => store.isNewSearch?.originalSearchType
  );

  const infoFlightsSearch = flightsSearch[originalSearchType || search_type];

  const [isLoadingResults, setIsLoadingResults] = useState(false);
  const [searchResults, setSearchResults] = useState({});

  const useQuery = () => new URLSearchParams(location.search);
  const query = useQuery();
  const idUrl = query.get('share');

  let newSearchResults = idUrl ? sharedSearch?.search_results : searchResults;

  const tripLegs = infoFlightsSearch?.dataTripLegs || [];
  const tripLegsLength = tripLegs.length;

  useEffect(() => {
    // Solo consideramos legs que tengan origen, destino y fecha
    const hasValidLegs = tripLegs.some(
      leg => leg.origin?.iata_code && leg.destination?.iata_code && leg.date
    );

    if (!idUrl && !hasValidLegs) {
      history.push(FLIGHTS);
    }
  }, [idUrl, tripLegs, history]);

  useEffect(() => {
    if (isNewSearch) {
      dispatch(setSharedSearch(null));
      setSearchResults({});
      query.delete('share');
      history.replace({ search: query.toString() });
    }

    if (idUrl && !sharedSearch && !isNewSearch) {
      getFlightsById(idUrl)
        .then(res => {
          setSearchData(res);
          dispatch(setSharedSearch(res));
        })
        .catch(err => console.error('err', err));
    }
  }, [isNewSearch, idUrl, sharedSearch, dispatch]);

  const onReloadSearch = () => {
    searchRef.current?.doSearch();
  };

  let content;
  if (newSearchResults?.clusters?.length > 0) {
    content = (
      <Search
        searchResults={newSearchResults}
        tripLegsLength={tripLegsLength}
        originalSearchType={originalSearchType}
        changeSearch={search_type !== originalSearchType}
      />
    );
  } else if (newSearchResults?.clusters?.length === 0) {
    content = <NoResultsFlight tripLegs={tripLegs} />;
  }

  return (
    <>
      <TabsHeader site={0} />

      <FlightsSearchForm
        setIsLoadingResults={setIsLoadingResults}
        isLoadingResults={isLoadingResults}
        setSearchResults={value => {
          value.search_type = search_type;
          setSearchResults(value);
        }}
        onRegisterSearchRef={ref => {
          searchRef.current = ref;
        }}
      />

      {(idUrl && !sharedSearch) || !search_type || isLoadingResults ? (
        <>
          <LoadingImage site={'Aereos'} isOpen={true} />
          <FlightsSearchSkeleton />
        </>
      ) : (
        content
      )}

      <TimedModal
        onReloadSearch={onReloadSearch}
        searchResults={newSearchResults}
      />
    </>
  );
};

export default FlightsSearch;
